import server from '../request';

// 工单数量
export const getWorkorderInfo = (data) => server.post('/xiaozi-xmb/wireless/saas/workOrder/board/workOrderNumber', data, {
  stopDefaultLoading: true,
});

// 工单动态
export const getWorkOrderDynamicInfo = (data) => server.post('/xiaozi-xmb/wireless/saas/workOrder/board/workOrderDynamic', data, {
  stopDefaultLoading: true,
});

// 工单趋势
export const getWorkOrderTrendInfo = (data) => server.post('/xiaozi-xmb/wireless/saas/workOrder/board/workOrderTrend', data, {
  stopDefaultLoading: true,
});

// 指标
export const getIndicatorInfo = (data) => server.post('/xiaozi-xmb/wireless/saas/workOrder/board/indicator', data, {
  stopDefaultLoading: true,
});

// 工单周期分布
export const getPeriodDistributionInfo = (data) => server.post('/xiaozi-xmb/wireless/saas/workOrder/board/periodDistribution', data, {
  stopDefaultLoading: true,
});

// 时长周期统计
export const getTheCycleTimeInfo = (data) => server.post('/xiaozi-xmb/wireless/saas/workOrder/board/theCycleTime', data, {
  stopDefaultLoading: true,
});

// 工程师周期排名
export const getEngineerCycleInfo = (data) => server.post('/xiaozi-xmb/wireless/saas/workOrder/board/engineerCycle', data, {
  stopDefaultLoading: true,
});

// 地图数据
export const getMapData = () => server.post('/xiaozi-xmb/wireless/saas/workOrder/board/mapData', {}, {
  stopDefaultLoading: true,
});

// 医院看板 chart
export const deviceStatistics = () => server.post('/xiaozi-xmb/wireless/saas/workOrder/board/deviceStatistics', {}, { stopDefaultLoading: true });

// 医院看板 chart
export const customStatistics = () => server.post('/xiaozi-xmb/wireless/saas/workOrder/board/customizedWorkOrderStatistics', {}, { stopDefaultLoading: true });
